import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import { fieldCanBeHidden } from '@jira/polaris__domain-field/src/toFieldKey.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';
import { createGetFieldByKey } from './createGetFieldByKey.tsx';

export const updateSystemFieldHidden =
	(fieldKey: FieldKey, hidden: boolean) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ onFieldUpdateFailed, fieldRemote, createAnalyticsEvent }: Props,
	): Promise<void> => {
		const field = createGetFieldByKey(fieldKey)(getState());
		if (!field || !fieldCanBeHidden(field.type) || field.configuration?.hidden === hidden) {
			return;
		}

		try {
			const configuration = {
				...field.configuration,
				hidden,
			};

			const fields = { ...getState().fields };
			setState({
				fields: {
					...fields,
					[fieldKey]: {
						...fields[fieldKey],
						configuration,
					},
				},
			});

			try {
				await fieldRemote.updateFieldConfiguration({
					oldConfiguration: field.configuration ?? {},
					configuration,
					fieldKey: field.key,
					type: 'updateSystemFieldHidden',
				});
			} catch (error) {
				const currentState = getState();
				const currentFields = currentState.fields;

				setState({
					fields: {
						...currentFields,
						[fieldKey]: {
							...currentFields[fieldKey],
							configuration: {
								...currentFields[fieldKey].configuration,
								hidden: field.configuration?.hidden ?? !hidden,
							},
						},
					},
				});

				throw error;
			}

			fireTrackAnalytics(createAnalyticsEvent({}), 'issueFields updated', {
				issueFieldKey: fieldKey,
				issueFieldType: field.type,
				updatedItems: [{ name: 'hidden' }],
			});
		} catch (error) {
			onFieldUpdateFailed(
				error instanceof Error ? error : new Error('failed to update system field hidden'),
			);
			throw error;
		}
	};
